import React from 'react';

import ReactDOM from 'react-dom';
import { Container } from './styles';

const ModalBanner = ({ showBanner, children, alinhamento, zIndex }) => {
  let estilo = {};
  let alinhamentoVertical = '';

  if (alinhamento != undefined) alinhamentoVertical = 'flex-end';
  else alinhamentoVertical = 'center';

  if (showBanner)
    estilo = {
      height: '100%',
      width: '100%',
      position: 'fixed',
      background: 'rgba(77, 77, 77, 0.70)',
      backdropFilter: 'blur(8px)',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      zIndex: zIndex || '999999999999999999',
      alignItems: alinhamentoVertical,
      marginBottom: '25px',
      justifyContent: 'center',
    };
  else {
    estilo = { display: 'none' };
  }

  return ReactDOM.createPortal(
    <div style={estilo} className='modalBanner2'>
      <div
        className='centralized'
        style={{
          height: '100%',
          width: '100%',
          paddingBottom: alinhamentoVertical == 'center' ? '0' : '15px',
          alignItems: alinhamentoVertical,
        }}
      >
        <Container className='container'>{children}</Container>
      </div>
    </div>,
    document.getElementById('modalOverlay')
  );
};

export default ModalBanner;
